import { VDIConfigData } from './config.types';

export const defaultConfigData: VDIConfigData = {
  VDI_SETTINGS: {
    IS_FORK_TRANSACTION_ENABLED: true,
    MMS: {
      AUTH: { HOST: '', AUTH_TYPE: '' },
      ENABLED: false,
      VERSION: '',
      GET_STATE: false,
      VDI_TYPES: [],
      VDI_HEADER: {
        XML_VERSION: '',
        PROVIDER_ID: '',
        APPLICATION_ID: '',
        APPLICATION_VERSION: '',
      },
    },
    VMS: {
      AUTH: { HOST: '', AUTH_TYPE: '' },
      ENABLED: false,
      VERSION: '',
      GET_STATE: false,
      VDI_TYPES: [],
      VDI_HEADER: {
        XML_VERSION: '',
        PROVIDER_ID: '',
        APPLICATION_ID: '',
        APPLICATION_VERSION: '',
      },
    },
    CLIENTS: {
      AUTH: { HOST: '', AUTH_TYPE: '' },
      ENABLED: false,
      VERSION: '',
      GET_STATE: false,
      VDI_TYPES: [],
    },
    ALERTS: {
      ENABLED: false,
      MMS: {
        AUTH: { HOST: '', AUTH_TYPE: '' },
        ENABLED: false,
        GET_STATE: false,
      },
      VMS: {
        AUTH: { HOST: '', AUTH_TYPE: '' },
        ENABLED: false,
        GET_STATE: false,
      },
      CLIENTS: {
        AUTH: { HOST: '', AUTH_TYPE: '' },
        ENABLED: false,
        GET_STATE: false,
      },
      GATEWAY: {
        AUTH: { HOST: '', AUTH_TYPE: '' },
        ENABLED: false,
        GET_STATE: false,
      },
    },
    SMART_COOLERS: {
      ENABLED: false,
      MMS: {
        AUTH: { HOST: '', AUTH_TYPE: '' },
        ENABLED: false,
        GET_STATE: false,
      },
      VMS: {
        AUTH: { HOST: '', AUTH_TYPE: '' },
        ENABLED: false,
        GET_STATE: false,
      },
      CLIENTS: {
        AUTH: { HOST: '', AUTH_TYPE: '' },
        ENABLED: false,
        GET_STATE: false,
      },
      GATEWAY: {
        AUTH: { HOST: '', AUTH_TYPE: '' },
        ENABLED: false,
        GET_STATE: false,
      },
    },
  },
  RECONCILIATION: {
    ENABLED: false,
  },
};
